import { useNavigate } from 'react-router-dom';
import { useSession } from '../lib/session';

// Phase 0: no purchase flow on web. Providers subscribe in the mobile app.
// This screen is shown both as a route (/subscribe) and, by SubscriptionGate,
// in place of the app when access has fully expired.

function Body({ expired }: { expired: boolean }) {
  const signOut = useSession((s) => s.signOut);
  const navigate = useNavigate();

  return (
    <div className="center-screen">
      <div className="card" style={{ maxWidth: 420, textAlign: 'center' }}>
        <div style={{ fontSize: 44, marginBottom: 14 }}>{expired ? '🔒' : '✦'}</div>
        <h1>{expired ? 'Free trial ended' : 'Manage your subscription'}</h1>
        <p className="muted" style={{ marginTop: 8 }}>
          Subscriptions for the Care Team portal are managed in the FASD Assist
          mobile app (App Store / Google Play). Open the app on your phone to
          start or renew your subscription, then sign in here again.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 22 }}>
          {!expired && (
            <button className="btn" onClick={() => navigate('/')}>
              Back to portal
            </button>
          )}
          <button
            className="btn btn--ghost"
            onClick={() => {
              signOut();
              navigate('/login', { replace: true });
            }}
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}

export function SubscribePage() {
  return <Body expired={false} />;
}

export function ExpiredScreen() {
  return <Body expired />;
}
